<ion-infinite-scroll
  *ngIf="isNextPageAvailable"
  (ionInfinite)="nextPage($event)"
  [ngClass]="classes"
>
  <!-- loadingSpinner icons: bubbles, circles, crescent, dots -->
  <ion-infinite-scroll-content
    loadingSpinner="crescent"
    loadingText="Loading more data..."
  >
  </ion-infinite-scroll-content>
</ion-infinite-scroll>
